import { render, staticRenderFns } from "./PantallaResultado.vue?vue&type=template&id=8f0df020"
import script from "./PantallaResultado.vue?vue&type=script&lang=js"
export * from "./PantallaResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports